module.exports = __webpack_public_path__ + "static/media/back_btn.3bda1ad5.svg";